<template>
  <div class="sidebar-menu shadow rounded-xl">
    <InputAvatar />

    <b-nav class="" v-b-scrollspy="headerHeight + 21">
      <b-nav-item
        href="#box-personal-data"
        @click="scrollIntoView"
        v-if="personalData"
        class="active"
      >
        <img src="@/assets/images/restoque/p1.svg" alt="" />
      </b-nav-item>
      <b-nav-item
        href="#box-education"
        @click="scrollIntoView"
        v-if="education"
      >
        <img src="@/assets/images/restoque/p2.svg" alt="" />
      </b-nav-item>
      <b-nav-item
        href="#box-professional-experience"
        @click="scrollIntoView"
        v-if="professionalExp"
      >
        <img src="@/assets/images/restoque/p3.svg" alt="" />
      </b-nav-item>
      <b-nav-item href="#box-language" @click="scrollIntoView" v-if="language">
        <img src="@/assets/images/restoque/p4.svg" alt="" />
      </b-nav-item>
      <!-- <b-nav-item href="#box-subscription" @click="scrollIntoView" v-if="subscriptions">
        <SubscriptionIcon />
      </b-nav-item> -->
    </b-nav>
  </div>
</template>

<script>
import InputAvatar from "ninenine-white-label/src/components/Media/InputAvatar.vue";
import PersonalDataIcon from "@/components/mlIcons/PersonalData";
import EducationIcon from "@/components/mlIcons/Education";
import ProfessionalExperienceIcon from "@/components/mlIcons/ProfessionalExperience";
import LanguageIcon from "@/components/mlIcons/Language";
import SubscriptionIcon from "@/components/mlIcons/Subscription";

export default {
  name: "ProfileSidebarMenu",

  data() {
    return {
      windowWidth: window.innerWidth,
      headerHeight: 0,
    };
  },

  props: {
    personalData: Boolean,
    education: Boolean,
    professionalExp: Boolean,
    language: Boolean,
    subscriptions: Boolean,
  },

  components: {
    InputAvatar,
    PersonalDataIcon,
    EducationIcon,
    ProfessionalExperienceIcon,
    LanguageIcon,
    SubscriptionIcon,
  },

  mounted() {
    this.headerHeight = document.getElementById("main-header").clientHeight;
  },

  methods: {
    scrollIntoView(evt) {
      evt.preventDefault();
      const href =
        evt.target.closest("a").getAttribute("href") ||
        evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      const viewportOffset = el.getBoundingClientRect();
      if (el) {
        window.scroll(
          0,
          viewportOffset.top + window.scrollY - this.headerHeight - 20
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-menu[data-v-2281c038] .nav-item.active .nav-link {
  box-shadow: none !important;
  background-color: transparent !important;
}
/deep/ .input-avatar {
  margin-bottom: 30px;

  .img {
    width: 90px;
    max-width: 90px;
    min-width: 90px;
    height: 90px;
    max-height: 90px;
    min-height: 90px;
    font-size: 100px;
    margin: 0;
    svg {
      width: 90px;
      height: 90px;
      color: #000;
    }
  }
  span {
    font-size: 0px;
  }
}

.sidebar-menu {
  width: 100%;
  position: sticky;
  top: 80px;
  background-color: #c4c4c4;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-radius: 4px;
  /deep/ .nav {
    flex-direction: column;
  }

  @include media-breakpoint-down(sm) {
    position: fixed;
    left: 0;
    top: auto;
    bottom: 0;
    max-width: none;
    flex-direction: row;
    z-index: 1;
    border-radius: 0;
    padding: 25px 15px 15px 15px;
    justify-content: center;

    /deep/ .nav {
      flex-direction: row;
    }

    /deep/ .input-avatar {
      margin: 0 15px 0 0;
      position: absolute;
      left: 50%;
      top: -30px;
      margin-left: -30px;
      img,
      .img {
        width: 60px;
        max-width: 60px;
        min-width: 60px;
        height: 60px;
        max-height: 60px;
        min-height: 60px;
        font-size: 60px;
      }
      img {
        border: 2px solid #fff;
      }
    }
  }

  /deep/ .nav-item {
    display: flex;
    justify-content: center;
    margin: auto;

    &.active {
      .nav-link {
        color: theme-color("blue-ml");
        background: #fff;
        box-shadow: $box-shadow;
      }
    }

    .nav-link {
      width: 80px;
      height: 80px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      border-radius: 0px;
      font-size: 24px;
    }
  }
}
</style>
